import { Divider } from "@material-ui/core"
import styled from "styled-components"

const StyledDivider = styled(Divider)`
  margin: 1em 16px !important;
`

export default StyledDivider
